/**
 * Refreshes ctx.user from store.
 *
 * @param {object} ctx
 * @param {any} ctx.store
 * @returns {false}
 */
export function ruleRefreshUser (ctx) {
    // console.log('🔍 обновление пользователя');
    ctx.user = ctx.store.state.pages?.user;

    return false;
}
